module.exports = __webpack_public_path__ + "static/media/appIcon.fe370501.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/components/header/appIcon.svg
// module id = 784
// module chunks = 0